<template>
  <div class="ajuda-wrap">
    <button class="ajuda-botao" @click="aberto = !aberto" :title="aberto ? 'Fechar ajuda' : 'Precisa de ajuda?'">
      <HelpCircle v-if="!aberto" :size="20" />
      <X v-else :size="20" />
    </button>

    <div v-if="aberto" class="ajuda-painel">
      <div class="ajuda-cabecalho">
        <strong>Ajuda</strong>
        <span>Pergunte qualquer coisa sobre o sistema</span>
      </div>
      <div class="ajuda-mensagens" ref="listaMsgs">
        <div v-if="mensagens.length === 0" class="ajuda-vazio">
          Oi! Manda sua dúvida que eu explico como funciona qualquer parte do sistema.
        </div>
        <div v-for="(m, i) in mensagens" :key="i" class="ajuda-msg" :class="m.autor === 'usuario' ? 'ajuda-msg-usuario' : 'ajuda-msg-ia'">
          {{ m.texto }}
        </div>
        <div v-if="carregando" class="ajuda-msg ajuda-msg-ia ajuda-digitando">Digitando...</div>
      </div>
      <div class="ajuda-rodape">
        <input
          type="text"
          v-model="pergunta"
          placeholder="Digite sua pergunta..."
          @keyup.enter="enviar"
          :disabled="carregando"
        />
        <button @click="enviar" :disabled="carregando || !pergunta.trim()">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiPost } from '../api'
import { HelpCircle, X } from 'lucide-vue-next'

export default {
  name: 'AjudaChat',
  components: { HelpCircle, X },
  data() {
    return {
      aberto: false,
      pergunta: '',
      mensagens: [],
      carregando: false
    }
  },
  methods: {
    async enviar() {
      const texto = this.pergunta.trim()
      if (!texto || this.carregando) return
      this.mensagens.push({ autor: 'usuario', texto })
      this.pergunta = ''
      this.carregando = true
      this.rolarParaFim()
      try {
        const historico = this.mensagens.slice(-8)
        const r = await apiPost('ajuda/perguntar', { pergunta: texto, historico })
        if (r.sucesso) this.mensagens.push({ autor: 'ia', texto: r.resposta })
        else this.mensagens.push({ autor: 'ia', texto: 'Não consegui responder agora. Tenta de novo em instantes.' })
      } catch (e) {
        this.mensagens.push({ autor: 'ia', texto: 'Erro de conexão. Tenta de novo.' })
      } finally {
        this.carregando = false
        this.rolarParaFim()
      }
    },
    rolarParaFim() {
      this.$nextTick(() => {
        const el = this.$refs.listaMsgs
        if (el) el.scrollTop = el.scrollHeight
      })
    }
  }
}
</script>

<style scoped>
.ajuda-wrap { position: fixed; right: 18px; bottom: 18px; z-index: 2000; }
.ajuda-botao {
  width: 52px; height: 52px; border-radius: 50%; margin: 0;
  background: var(--brand-700, #4a5c2f); color: #fff; font-size: 20px; font-weight: 800;
  box-shadow: 0 6px 18px rgba(0,0,0,.22); border: none; cursor: pointer;
}
.ajuda-painel {
  position: fixed; right: 18px; bottom: 82px; width: 320px; max-width: calc(100vw - 32px);
  height: 440px; max-height: calc(100vh - 120px); background: #fff; border-radius: 14px;
  box-shadow: 0 10px 40px rgba(0,0,0,.25); display: flex; flex-direction: column; overflow: hidden;
}
.ajuda-cabecalho { background: var(--brand-700, #4a5c2f); color: #fff; padding: 14px 16px; }
.ajuda-cabecalho strong { display: block; font-size: 14px; }
.ajuda-cabecalho span { font-size: 11px; opacity: .85; }
.ajuda-mensagens { flex: 1; overflow-y: auto; padding: 12px; display: flex; flex-direction: column; gap: 8px; background: #f8f9f6; }
.ajuda-vazio { color: #999; font-size: 12px; text-align: center; padding: 20px 10px; }
.ajuda-msg { max-width: 85%; padding: 8px 11px; border-radius: 10px; font-size: 12.5px; line-height: 1.4; white-space: pre-wrap; }
.ajuda-msg-usuario { align-self: flex-end; background: var(--brand-700, #4a5c2f); color: #fff; border-bottom-right-radius: 3px; }
.ajuda-msg-ia { align-self: flex-start; background: #fff; border: 1px solid #e8e8e2; color: #333; border-bottom-left-radius: 3px; }
.ajuda-digitando { color: #999; font-style: italic; }
.ajuda-rodape { display: flex; gap: 6px; padding: 10px; border-top: 1px solid #eee; background: #fff; }
.ajuda-rodape input { flex: 1; margin: 0; padding: 9px 10px; font-size: 12.5px; }
.ajuda-rodape button { margin: 0; padding: 9px 14px; font-size: 12px; }
@media (max-width: 480px) {
  .ajuda-painel { right: 12px; left: 12px; width: auto; bottom: 76px; }
  .ajuda-wrap { right: 12px; bottom: 12px; }
}
</style>
